import { createContext, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LoadedCompContext = createContext<any>({});

export const useLoadedCompContext = () => {
  return useContext(LoadedCompContext);
};
